import {css} from "lit";

export const contentSliderOnDarkStyles = css`
    --_slider-button__bg--focus: var(--sbkSliderControlBgColorSecondaryEnabled);
    --_slider-button__color--focus: var(--sbkSliderControlFgColorOnDarkEnabled);
    --_slider-button__border--focus:var(--sbkSliderControlBorderOnDarkFocus);
    
    --_slider-button__border-color--active: var(--sbkSliderControlBorderOnDarkActive);
    --_slider-button__bg--active: var(--sbkSliderControlBgColorSecondaryActive);
    --_slider-button__color--active:var(--sbkSliderControlFgColorOnLightEnabled);
    --_slider-button__bg--hover: var(--sbkSliderControlBgColorSecondaryHover);
    --_slider-button__color--hover: var(--sbkSliderControlFgColorOnDarkHover);
    --_slider-button__border--hover:var(--sbkSliderControlBorderOnDarkHover);
    --_slider-button__color: var(--sbkSliderControlFgColorOnDarkEnabled);
    --_slider-button__bg: var(--sbkSliderControlBgColorSecondaryEnabled);
    --_slider-button__border: var(--sbkSliderControlBorderOnDarkEnabled);
    --_slider-pagination__color:var(--sbkSliderControlFgColorOnDarkEnabled);
`;

